<template>
  <div class="blog-block blog-quote">
    <div class="blog-quote__content" v-html="data.text"></div>
  </div>
</template>

<script>
export default {
  name: 'blog-quote',

  props: ['data'],
};
</script>

<style lang="scss" scoped>
.blog-quote {
  &__content {
    padding: 0 calc((100vw / 32) * 3);
    opacity: 0.75;

    font-size: rem(35px);
    font-size: calc(35px * var(--rw));
    line-height: rem(45px);
    line-height: calc(45px * var(--rw));
    font-style: italic;
  }
}
</style>
